
import { Sidebar } from "@/components/layout/Sidebar";
import { MainContent } from "@/components/layout/MainContent";
import { useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useSidebar } from "@/context/SidebarContext";
import { VersionBadge } from "./VersionBadge";

export function Layout() {
  const location = useLocation();
  const { diagramId } = useParams<{ diagramId?: string }>();
  const { setCurrentPage } = useSidebar();
  
  // Set the correct current page based on the URL
  useEffect(() => {
    if (location.pathname.startsWith('/leia-me')) {
      setCurrentPage("Leiame");
    } else if (location.pathname.startsWith('/componentes') || location.pathname.startsWith('/componente-detalhes')) {
      setCurrentPage("Componentes");
    } else if (location.pathname.startsWith('/tipos-componentes')) {
      setCurrentPage("TiposComponentes");
    } else if (location.pathname.startsWith('/configuracoes')) {
      setCurrentPage("Configuracoes");
    } else if (location.pathname.startsWith('/diagramas') || location.pathname.startsWith('/diagrama-detalhes')) {
      setCurrentPage("Diagramas");
    } else if (location.pathname === '/') {
      setCurrentPage("Dashboard");
    } else {
      setCurrentPage("Dashboard");
    }
  }, [location, setCurrentPage]);
  
  return (
    <div className="flex h-screen w-full overflow-hidden">
      <Sidebar />
      <MainContent />
      <div className="absolute bottom-4 right-4">
        <VersionBadge />
      </div>
    </div>
  );
}
